import type { LogEntry } from "@skaile/workspaces/types";

/**
 * Shape of a row returned by `SELECT ... FROM log_entries`. Matches the
 * schema written by the agent container's `LogStore` (see
 * `workspaces/core/src/logging`).
 */
export interface SqliteLogRow {
  id: string;
  timestamp: string;
  session_id: string;
  kind: string;
  subkind: string;
  instance: string | null;
  level: string;
  message: string;
  data_json: string | null;
  error_json: string | null;
}

/**
 * Convert a raw SQLite row into a typed `LogEntry`. Used by both the
 * one-shot history query (`local-query`) and the live tail loop
 * (`local-tail`) so the formatter sees identical shapes from either path.
 */
export function rowToEntry(row: SqliteLogRow): LogEntry {
  return {
    id: row.id,
    timestamp: row.timestamp,
    sessionId: row.session_id,
    source: {
      kind: row.kind as LogEntry["source"]["kind"],
      subkind: row.subkind,
      ...(row.instance ? { instance: row.instance } : {}),
    },
    level: row.level as LogEntry["level"],
    message: row.message,
    ...(row.data_json ? { data: JSON.parse(row.data_json) as Record<string, unknown> } : {}),
    ...(row.error_json ? { error: JSON.parse(row.error_json) as LogEntry["error"] } : {}),
  };
}
